// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InstituteTitle{
    text-align: center;
    color: #2A72DE;
}
.InstitutePhotoAddress{
    margin-left: 15%;
    margin-right: 15%;
    margin-top: 10%;
    display: flex;
    flex-direction: row;
    gap: 5%;
}
.InstituteDescription{
    margin-left: 15%;
    margin-right: 15%;
    margin-top: 10%;
}
.JobInnerCard{
    padding: 24px;
}
.JobCardImgDiv{
    width: 71px;
    height: 60px;
}
.JobCardImgDiv img{
    width: 71px;
    height: 60px;
    border-radius: 10px;
}
.applicationTop{
    display: flex;
    flex-direction: row;
    padding-top: 2%;
}
.grid-container {
    display: grid;
    grid-template-columns: auto auto auto auto;
    background-color: #ffffff;
    padding: 10px;
  }
  .grid-item {
    background-color: rgba(255, 255, 255, 0.8);
    border: 1px solid rgba(0, 0, 0, 0.8);
    padding: 20px;
    text-align: center;
  }
.next_btn{
    margin-left: auto;
    padding: 0 16px; 
    padding-top:1rem;
    padding-bottom: 1rem;
    display: flex; 
    align-items: center; 
    justify-content: end; 
    font-family: Poppins; /* Body */
    font-size: 16px; 
    line-height: 26px; 
    color: #FFFFFFFF; /* white */
    background: #535CE8FF; /* primary-500 */
    opacity: 1; 
    border: none; 
    border-radius: 6px; /* border-m */
}
.ApplicationSteps{
    display: flex;
    justify-content: center;
    margin-top: 4%;
}
.changebodycolor{
    margin: 0%;
    background-color: #ffffff;
  min-height: 100vh;
}


`, "",{"version":3,"sources":["webpack://./src/assets/css/Careersite.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,OAAO;AACX;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,aAAa;IACb,0CAA0C;IAC1C,yBAAyB;IACzB,aAAa;EACf;EACA;IACE,0CAA0C;IAC1C,oCAAoC;IACpC,aAAa;IACb,kBAAkB;EACpB;AACF;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB,EAAE,SAAS;IAC/B,eAAe;IACf,iBAAiB;IACjB,gBAAgB,EAAE,UAAU;IAC5B,qBAAqB,EAAE,gBAAgB;IACvC,UAAU;IACV,YAAY;IACZ,kBAAkB,EAAE,aAAa;AACrC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,UAAU;IACV,yBAAyB;EAC3B,iBAAiB;AACnB","sourcesContent":[".InstituteTitle{\n    text-align: center;\n    color: #2A72DE;\n}\n.InstitutePhotoAddress{\n    margin-left: 15%;\n    margin-right: 15%;\n    margin-top: 10%;\n    display: flex;\n    flex-direction: row;\n    gap: 5%;\n}\n.InstituteDescription{\n    margin-left: 15%;\n    margin-right: 15%;\n    margin-top: 10%;\n}\n.JobInnerCard{\n    padding: 24px;\n}\n.JobCardImgDiv{\n    width: 71px;\n    height: 60px;\n}\n.JobCardImgDiv img{\n    width: 71px;\n    height: 60px;\n    border-radius: 10px;\n}\n.applicationTop{\n    display: flex;\n    flex-direction: row;\n    padding-top: 2%;\n}\n.grid-container {\n    display: grid;\n    grid-template-columns: auto auto auto auto;\n    background-color: #ffffff;\n    padding: 10px;\n  }\n  .grid-item {\n    background-color: rgba(255, 255, 255, 0.8);\n    border: 1px solid rgba(0, 0, 0, 0.8);\n    padding: 20px;\n    text-align: center;\n  }\n.next_btn{\n    margin-left: auto;\n    padding: 0 16px; \n    padding-top:1rem;\n    padding-bottom: 1rem;\n    display: flex; \n    align-items: center; \n    justify-content: end; \n    font-family: Poppins; /* Body */\n    font-size: 16px; \n    line-height: 26px; \n    color: #FFFFFFFF; /* white */\n    background: #535CE8FF; /* primary-500 */\n    opacity: 1; \n    border: none; \n    border-radius: 6px; /* border-m */\n}\n.ApplicationSteps{\n    display: flex;\n    justify-content: center;\n    margin-top: 4%;\n}\n.changebodycolor{\n    margin: 0%;\n    background-color: #ffffff;\n  min-height: 100vh;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
